import VueGtag from 'vue-gtag'
import configuration from '@/config'

export default {
  install (Vue, router) {
    Vue.use(VueGtag, {
      config: { id: configuration.GOOGLE_ANALYTICS_ID },
      bootstrap: false
    }, router)
  }
}
